export default {
  firstTest: {
    flags: {
      test: 0.5,
      control: 0.5,
      excluded: 0
    }
  }
};
